import { faFile } from '@fortawesome/pro-light-svg-icons/faFile'

import { Icon } from 'src/components'
import i18n from 'src/i18n'
import { getCommentDocument } from 'src/client/Comments'
import { convertSizeFile } from './utils'
import { PdfPreviewProps } from './pdfPreview.types'
import { Container, DataFile, Preview, TextFileName } from './pdfPreview.styles'

const PdfPreview = ({
  newsId,
  commentId,
  fileName,
  pagesCount,
  thumbnailUrl,
  contentLength
}: PdfPreviewProps) => {
  const handleOpenPdf = async () => {
    const commentMediaSrc = await getCommentDocument(newsId, commentId)
    window.open(`${commentMediaSrc}`, '_blank')
  }

  return (
    <Container
      data-test="pdf-preview"
      className="_d-flex _flex-column _border _border-gray-200 _rounded-lg _cursor-pointer"
      onClick={handleOpenPdf}
    >
      <div>
        {thumbnailUrl && <Preview className="_bg-gray-400 _w-full" thumbnailUrl={thumbnailUrl} />}

        <DataFile className="_w-full _d-flex _align-items-center _pl-4">
          <div className="_mr-3">
            <Icon icon={faFile} size={'lg'} className="_text-gray-900" />
          </div>
          <div className="_d-flex _flex-column">
            <TextFileName className="_text-gray-900 _text-1 _font-weight-bold">
              {fileName}
            </TextFileName>
            <div className="_text-gray-500 _text-1">
              {pagesCount === 1 ? (
                <span>{i18n.t('comment_media.page_one', { count: pagesCount })}</span>
              ) : (
                <span>{i18n.t('comment_media.page_other', { count: pagesCount })}</span>
              )}{' '}
              - {contentLength && convertSizeFile(contentLength)} - PDF
            </div>
          </div>
        </DataFile>
      </div>
    </Container>
  )
}

export default PdfPreview
